import script from "./ConversionMatrix.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConversionMatrix.vue?vue&type=script&lang=ts&setup=true"

import "./ConversionMatrix.vue?vue&type=style&index=0&id=b64555c4&scoped=true&lang=scss"
import "./ConversionMatrix.vue?vue&type=style&index=1&id=b64555c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b64555c4"]])

export default __exports__